export default __webpack_public_path__ + "c169acb0a69a070f2c346597eb85e89f.png";